import type { MagentoApiGetCustomerOrdersStatusesQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCustomerOrdersStatusesEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerOrdersStatuses: builder.query<MagentoApiGetCustomerOrdersStatusesQueryResponse, void>({
    query: () => ({
      method: "getCustomerOrdersStatuses",
      params: [],
    }),
    providesTags: [TAGS.ORDER],
  }),
});
